import React, { Component } from "react";

class Location extends Component {
  render() {
    return (
      <div className="main-content">
        <div className="section-title standalone">
          <p>PICK-UP LOCATION</p>
          <div className="sep" />
        </div>
        <p className="map-area-text">TEXAS AREA</p>
        <div className="map-holder">
          <div id="map">
            <iframe
              title="google-maps-embed"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55161.27174273312!2d-97.79681590384274!3d30.220547345438444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644b5418c6013dd%3A0x19f707cae2e1be40!2sStareway+Films!5e0!3m2!1sen!2sma!4v1540401857010"
              frameborder="0"
              style={{
                width: "100%",
                height: "100%"
              }}
              allowfullscreen
            />
          </div>
          <div className="address-card">
            <div className="adrs-head">
              <p>STAREWAY AUSTIN TEXAS HQ</p>
            </div>
            <div className="adrs-info">
              <p>
                <b>ADDRESS</b>
                <br />
                209 E. Ben White Blvd.
                <br />
                Suite 111
                <br /> Austin, Texas 78704
              </p>
              <p>
                <b>MONDAY - FRIDAY</b>
                <br />
                9:00AM - 6:00PM
                <br />
                <b>SATURDAY</b>
                <br />
                10:00AM - 4:00PM
              </p>
            </div>
            <div className="ship-info">
              <p>
                <b>PICKUP TIME</b>
                <br />
                Same Day Pick-up
              </p>
              <p>
                <b>Pick-Up Fee</b>
                <br />
                FREE
              </p>
              <p>
                <b>PHONE</b>
                <br />
                +1 (512) 222-7186
              </p>
            </div>
          </div>
        </div>
        <div className="section-title standalone">
          <p>CONTACT US</p>
          <div className="sep" />
        </div>
        <div className="contact-container">
          <div className="sec-banner">
            <div className="overlay" />
            <h2>EMAIL US TODAY</h2>
          </div>
          <h2>Get in touch</h2>
          <p>And we will contact you as soon as possible</p>
          <div className="contact-inputs">
            <div className="input-container">
              <input type="text" placeholder="Your Name" />
            </div>
            <div className="input-container">
              <input type="text" placeholder="E-mail" />
            </div>
            <div className="input-container">
              <input type="text" placeholder="Phone" />
            </div>
          </div>
          <textarea type="text" placeholder="Message" />
          <div className="action-btn">
            <button>Submit</button>
          </div>
        </div>
      </div>
    );
  }
}

export default Location;



// WEBPACK FOOTER //
// ./src/components/Location.js